import { render, staticRenderFns } from "./setApprove.vue?vue&type=template&id=154bafc9&scoped=true&"
import script from "./setApprove.vue?vue&type=script&lang=js&"
export * from "./setApprove.vue?vue&type=script&lang=js&"
import style0 from "./setApprove.vue?vue&type=style&index=0&id=154bafc9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154bafc9",
  null
  
)

export default component.exports